import "./dismiss";



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/alert-bar/index.js